import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AppRoutes from "./routes";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { ToastContainer } from "react-toastify";
import { NotificationProvider } from './context/NotificationContext';

function App() {
    return (
        <Router>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Provider store={store}>
                    <AuthProvider>
                        <NotificationProvider>
                            <AppRoutes />
                        </NotificationProvider>
                    </AuthProvider>
                </Provider>
                <ToastContainer
                    position="top-right"
                    autoClose={4000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </ThemeProvider>
        </Router>
    );
}

export default App;
